import { Drawer, message, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createCategory, updateCategory } from "../../../core/data/redux/payroll/Accounting/expensesCategories/expensesCategoriesAction";
import { status } from "../../../core/common/selectoption/selectoption";
import { AppDispatch } from "../../../core/data/redux/store";

const CategoriesModal: React.FC<any> = ({ modalType, handleCancel, isModalVisible, selectedRowData }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { loadingStates } = useSelector((state: any) => state.accounting.expensesCategories);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;


  const [formData, setFormData] = useState({
    category: "",
    subCategory: "",
    status: "active",
    createdBy: user?.UserId || 1,
  });

  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (modalType === "edit" && selectedRowData) {
      setFormData({
        category: selectedRowData.category,
        subCategory: selectedRowData.subCategory,
        status: selectedRowData.status,
        createdBy: user?.UserId || 1,
      });
      setErrors({});
    } else {
      resetForm();
    }
  }, [modalType, selectedRowData]);

  const resetForm = () => {
    setFormData({
      category: "",
      subCategory: "",
      status: "active",
      createdBy: user?.UserId || 1,
    });
    setErrors({});
  };

  const handleChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev: any) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors: any = {
      category: "",
      subCategory: "",
      status: "",
    };

    if (!formData.category.trim()) {
      newErrors.category = "Category name is required.";
      valid = false;
    }

    if (!formData.subCategory.trim()) {
      newErrors.subCategory = "Sub category name is required.";
      valid = false;
    }

    if (!formData.status) {
      newErrors.status = "Status is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      if (modalType === "edit") {
        const payloadWithModifiedBy = {
          ...formData,
          modifiedBy: user?.id || 1, 
        };
        await dispatch(updateCategory({ id: selectedRowData.expenses_categories_id, data: payloadWithModifiedBy })).unwrap();
        message.success("Category updated successfully");
      } else {
        await dispatch(createCategory(formData)).unwrap();
        message.success("Category created successfully");
      }
      handleCancel();
      resetForm();
    } catch (err: any) {
      const errorMsg = err?.error || err?.message || err?.payload?.error || "Something went wrong. Please try again.";
      message.error(errorMsg);
    }
  };

  return (
    <Drawer
      title={modalType === "edit" ? "Edit Expenses Category" : "Add Expenses Category"}
      placement="right"
      width={400}
      onClose={() => {
        handleCancel();
        resetForm();
      }}
      visible={isModalVisible}
      style={{ marginTop: 50, paddingBottom: 50 }}
    >
      <form>
        <div className="modal-body pb-0">
          <div className="mb-3">
            <label className="form-label">Category Name</label>
            <input
              type="text"
              className={`form-control ${errors.category ? "is-invalid" : ""}`}
              value={formData.category}
              onChange={(e) => handleChange("category", e.target.value)}
            />
            {errors.category && <div className="invalid-feedback">{errors.category}</div>}
          </div>
          <div className="mb-3">
            <label className="form-label">Sub Category Name</label>
            <input
              type="text"
              className={`form-control ${errors.subCategory ? "is-invalid" : ""}`}
              value={formData.subCategory}
              onChange={(e) => handleChange("subCategory", e.target.value)}
            />
            {errors.subCategory && <div className="invalid-feedback">{errors.subCategory}</div>}
          </div>
          <div className="mb-3">
            <label className="form-label">Status</label>
            <Select
              value={formData.status}
              onChange={(value) => handleChange("status", value)}
              className={`w-100 ${errors.status ? "is-invalid-select" : ""}`}
            >
              {status.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
            {errors.status && <div className="text-danger mt-1">{errors.status}</div>}
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-white border me-2"
            onClick={() => {
              handleCancel();
              resetForm();
            }}
          >
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? (
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            ) : null}
            {modalType === "edit" ? "Update Category" : "Add Category"}
          </button>
        </div>
      </form>
    </Drawer>
  );
};

export default CategoriesModal;
